import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import WidgetNodeType from "../../types/WidgetNodeType";

export const Widget = ({ children, ...props }: any & WidgetNodeType) =>
    (<Card {...props}><CardContent>{children}</CardContent></Card>);
export default Widget;